import { render } from "./OptionMaker.vue?vue&type=template&id=070a7196&scoped=true"
import script from "./OptionMaker.vue?vue&type=script&lang=js"
export * from "./OptionMaker.vue?vue&type=script&lang=js"

import "./OptionMaker.vue?vue&type=style&index=0&id=070a7196&scoped=true&lang=css"

import exportComponent from "/home/tewky/cloverhitch/pelican/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a7196"]])

export default __exports__